import * as React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { getCurrentRichContent } from "../helpers/richContentHelpers";
import { wpImage } from "./fragments";

const indexPageData = () => {
    const data = useStaticQuery(
        graphql`
            {
                allWpPage {
                    edges {
                        node {
                            id
                            isFrontPage
                            template {
                                ... on WpTemplate_FrontPage {
                                    frontpageRichContent {
                                        # SECTION: Hero
                                        hero {
                                            category
                                            header
                                            secondHeader
                                            animatedBackground
                                            logosLabel
                                            logos {
                                                image {
                                                    ...wpImage
                                                }
                                            }
                                            text
                                            buttons {
                                                button {
                                                    variant
                                                    link {
                                                        target
                                                        title
                                                        url
                                                    }
                                                }
                                            }
                                            image {
                                                localFile {
                                                    extension
                                                    childImageSharp {
                                                        gatsbyImageData(
                                                            width: 1800
                                                            placeholder: BLURRED
                                                            quality: 100
                                                        )
                                                    }
                                                }
                                            }
                                            backgroundImage {
                                                localFile {
                                                    extension
                                                    childImageSharp {
                                                        gatsbyImageData(
                                                            width: 1800
                                                            placeholder: BLURRED
                                                            quality: 100
                                                        )
                                                    }
                                                }
                                            }
                                        }
                                        heroFloatingBadges {
                                            badges {
                                                image {
                                                    ...wpImageFluid
                                                }
                                                label
                                                positionX
                                                positionY
                                            }
                                        }

                                        # SECTION: Connectivity Logos
                                        logosSection {
                                            header
                                            text
                                            textAlign
                                            logos {
                                                image {
                                                    ...wpImage
                                                }
                                            }
                                            logosAlign
                                            numberOfRowsDesktop
                                            numberOfColumnsMobile
                                        }

                                        # SECTION: Why Choose
                                        whyChoose {
                                            header
                                            items {
                                                title
                                                description
                                            }
                                        }

                                        # SECTION: Key Benefits
                                        keyBenefits {
                                            slug
                                            header
                                            description
                                            benefits {
                                                icon {
                                                    ...wpImageFluid
                                                }
                                                title
                                                description
                                            }
                                        }

                                        # SECTION: Trade Layer Lottie animation
                                        tradeLayer {
                                            slug
                                            header
                                            description
                                            bottomText
                                            lottieSrc {
                                                localFile {
                                                    publicURL
                                                }
                                            }
                                            lottieSrcMobile {
                                                localFile {
                                                    publicURL
                                                }
                                            }
                                        }

                                        # SECTION: Solutions Cards
                                        solutionsOverview {
                                            slug
                                            header
                                            description
                                            items {
                                                title
                                                description
                                                image {
                                                    ...wpImage
                                                }
                                                button {
                                                    variant
                                                    link {
                                                        target
                                                        title
                                                        url
                                                    }
                                                }
                                                secondButton {
                                                    variant
                                                    link {
                                                        target
                                                        title
                                                        url
                                                    }
                                                }
                                            }
                                        }

                                        # SECTION: Social Proof
                                        socialProof {
                                            trustedByHeader
                                            trustedByLogos {
                                                image {
                                                    ...wpImageFluid
                                                }
                                            }
                                            testimonials {
                                                quote
                                                companyLogo {
                                                    ...wpImageFluid
                                                }
                                            }
                                        }

                                        # SECTION: Image Section
                                        imageSection {
                                            category
                                            title
                                            text
                                            slug
                                            variant
                                            image {
                                                ...wpImageFluid
                                            }
                                            items {
                                                category
                                                title
                                                text
                                                button {
                                                    variant
                                                    link {
                                                        target
                                                        title
                                                        url
                                                    }
                                                }
                                            }
                                        }

                                        # SECTION: Security
                                        securitySection {
                                            slug
                                            header
                                            description
                                            features {
                                                icon {
                                                    ...wpImage
                                                }
                                                text
                                            }
                                            certificationText
                                            certificationImages {
                                                badge {
                                                    ...wpImage
                                                }
                                            }
                                        }

                                      # SECTION: Request Demo Banner (per page, falls back to theme settings)
                                      requestDemoBanner {
                                        header
                                        description
                                        button {
                                          target
                                          title
                                          url
                                        }
                                      }

                                      # SECTION: FAQ
                                      faqSection {
                                        header
                                        items {
                                          question
                                          answer
                                        }
                                    }
                                    }
                                }
                                }
                        }
                    }
                }
            }
        `
    );
    return getCurrentRichContent(data, "frontpage", "frontpageRichContent");
};

export { indexPageData };
